



import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { ObsoleteExternalRecord, ObsoleteExternalRecordResponse } from "../../api/dtos/dtos";
import usePost from "../api/usePost";

const getData = (response?: SWRResponse<ObsoleteExternalRecordResponse, ObsoleteExternalRecordResponse>) => response?.data;
const getError = (response?: SWRResponse<ObsoleteExternalRecordResponse, ObsoleteExternalRecordResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<ObsoleteExternalRecordResponse, ObsoleteExternalRecordResponse>) => ({});

const usePostObsoleteExternalRecord = (query?: Partial<ObsoleteExternalRecord>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query || !query.id) {
            return undefined;
        }

        return () => {
            return new ObsoleteExternalRecord(query);
        }
    }, [query]);

    return usePost(request, { getData, getError, getAdditionalState }, configuration);
}

export default usePostObsoleteExternalRecord;